import { Assessment } from "../../globals/types";

function getAssessmentStatus(
    assessment: Pick<Assessment, "submittedAt" | "answeredQuestionIds">
): "Submitted" | "InProgress" | "NotStarted" {
    if (assessment.submittedAt) {
        return "Submitted";
    }
    if (assessment.answeredQuestionIds.length > 0) {
        return "InProgress";
    }
    return "NotStarted";
}

export { getAssessmentStatus };
